import React, { useRef, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import SearchInput from "../../../common/SearchInputField";
import useClickOutside from "../../../../hooks/useClickOutside";
import { ReactComponent as Dropdown } from "../../../../assets/images/dropdown-arrow.svg";

const OPTIONS = [
  { value: "all", label: "All Tags" },
  { value: "conversation", label: "Conversation" },
  { value: "knowledge_base", label: "Knowledge Base" },
];

export default function TagToolbar({ searchQuery, onSearchChange, typeFilter, onTypeFilterChange }) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useClickOutside(wrapperRef, () => setOpen(false));

  const selectedLabel =
    OPTIONS.find((opt) => opt.value === typeFilter)?.label || "All Tags";

  return (
    <Box sx={{ pt: "24px", pb: 3 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
        <Box sx={{ width: 296, flex: "0 0 296px" }}>
          <SearchInput
            placeholder="Search tags..."
            value={searchQuery}
            className="SearchInputField-article"
            onChange={(e) => onSearchChange(e.target.value)}
            iconPosition="left"
            iconGap={8}
            style={{ width: 296 }}
            inputStyle={{ width: 296 }}
            noTitle
            iconVariant="people"
          />
        </Box>
        <Box ref={wrapperRef} sx={{ position: "relative" }}>
          <Box
            onClick={() => setOpen((prev) => !prev)}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: 164,
              height: 40,
              px: 1.5,
              borderRadius: "8px",
              border: "1px solid #D5DCE1",
              background: "#FFF",
              boxShadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
              cursor: "pointer",
            }}
          >
            <Typography sx={{ color: "#405261", fontSize: 14, fontFamily: "Inter" }}>
              {selectedLabel}
            </Typography>
            <Dropdown
              style={{
                width: 16,
                height: 16,
                transform: open ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.2s",
              }}
            />
          </Box>
          {open ? (
            <Box
              sx={{
                position: "absolute",
                top: "48px",
                left: 0,
                width: 164,
                borderRadius: "8px",
                border: "1px solid #D5DCE1",
                background: "#FFF",
                boxShadow: "0 15px 20px 0 rgba(6, 21, 34, 0.05)",
                zIndex: 10,
                overflow: "hidden",
              }}
            >
              {OPTIONS.map((opt) => (
                <Box
                  key={opt.value}
                  onClick={() => {
                    onTypeFilterChange(opt.value);
                    setOpen(false);
                  }}
                  sx={{
                    px: 1.5,
                    py: 1,
                    cursor: "pointer",
                    color: typeFilter === opt.value ? "#061522" : "#405261",
                    fontFamily: "Inter",
                    fontSize: 14,
                    fontWeight: typeFilter === opt.value ? 500 : 400,
                    "&:hover": { background: "#F9FAFA" },
                  }}
                >
                  {opt.label}
                </Box>
              ))}
            </Box>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
}
